import { Component, HostListener } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { NgClass } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import { ToastrService } from '@shared-angular/services/toastr.service';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { DrawerModule } from 'primeng/drawer';
import { PopoverModule } from 'primeng/popover';
import { PreviewComponent } from '../preview/preview.component';
import { EmbedTabComponent } from '../routes/ai-bot/admin/tabs/general/embed-tab/embed-tab.component';
import { AdminPositionBubbleComponent } from '../shared/components/ai-bot/utils/admin-position-bubble/admin-position-bubble.component';
import { ProjectNamePipe } from '../shared/pipes/project-name.pipe';
import { ProjectService } from '../shared/services/project.service';
import { RouteShareService } from '../shared/services/route-share.service';

@Component({
  selector: 'app-page-header-over-editor',
  imports: [RouterLink, NgClass, DrawerModule, FormsModule, DialogModule, PopoverModule, EmbedTabComponent, PreviewComponent, ProjectNamePipe, AdminPositionBubbleComponent, ButtonModule],
  templateUrl: './page-header-over-editor.component.html',
  styleUrl: './page-header-over-editor.component.scss'
})
export class PageHeaderOverEditorComponent {
  public showExportPanel = false;
  public isScrolled = false;
  public backupBotName = '';
  public editBotNameMode = false;
  constructor(public toastr: ToastrService, public rss: RouteShareService, private router: Router, public projectService: ProjectService) { }


  @HostListener('window:scroll', [])
  public onWindowScroll() {
    this.isScrolled = window.scrollY > 100;
  }

  public async saveNameToBotConfig() {
    if (this.rss.botConfig.name.trim() == "") {
      this.toastr.error("SAVED", $localize`:@@emptyName:Bitte gib einen Namen ein.`);
      this.rss.botConfig.name = this.backupBotName;
      this.backupBotName = '';
    } else {
      this.rss.botConfig.name = this.rss.botConfig.name.trim();
      await this.rss.saveBotConfigField('name');
    }
  }

  public getProjectRoute() {
    const baseRoute: string[] = ['/', 'bot-admin'];
    if (this.rss.botConfig.thisIsTrash) {
      return [...baseRoute, 'trash'];
    } else if (this.rss.botConfig.archived) {
      return [...baseRoute, 'archive'];
    } else if (this.rss.botConfig.projectId) {
      return [...baseRoute, 'project', this.rss.botConfig.projectId];
    } else {
      return [...baseRoute, 'project', '-'];
    }
  }

  public backToHome() {
    this.rss.editorItem = undefined;
    this.rss.editorItems = this.rss.setEmptyEditorList();
  }


}

